
const page = {
  state: {
    actionRecord: {
      orderlist_date: []
    },
    goods_info: {},
    config: {},
    mask_left: 0,
    sysPage: [
      { label: '首页', value: '/pages/pageTo/pageTo' },
      { label: '点餐(默认)', value: '/pages/classify/classify' },
      { label: '点餐(自取)', value: '/pages/classify/classify?type=zq' },
      { label: '点餐(外卖)', value: '/pages/classify/classify?type=ps' },
      { label: '点餐(堂食)', value: '/pages/classify/classify?type=ts' },
      { label: '打开分类，0为第一个，以此类推', value: '/pages/classify/classify?classIndex=0' },
      { label: '会员码', value: '/pages/code/code' },
      { label: '预约', value: '/pages/booking/booking' },
      { label: '充值', value: '/pages/topUp/topUp' },
      { label: '充值记录', value: '/pages/rechargeList/rechargeList' },
      { label: '我的订单', value: '/pages/order/order' },
      { label: '个人中心', value: '/pages/my/my' },
      { label: '优惠券', value: '/pages/coupon/coupon' },
      { label: '我的优惠券', value: '/pages/ticket/ticket' },
      { label: '选择门店', value: '/pages/storeList/storeList' },
      { label: '门店预约', value: '/pages/book-list/book-list' },
      { label: '商品拼团', value: '/pages/assemble/assemble' },
      { label: '积分管理', value: '/packageA/pages/jifensc/jifensc' },
      { label: '幸运大转盘', value: '/pages/webView/webView?url=https://zhyx.eingdong.com/game/zhuanpan' },
      { label: '刮刮乐', value: '/pages/webView/webView?url=https://zhyx.eingdong.com/game/guaguale' },
      { label: '我的粉丝', value: '/packageA/pages/myfans/myfans' },
      { label: '我的地址', value: '/pages/myaddress/myaddress' },
      { label: 'WIFI', value: '/pages/wifi/wifi' },
      { label: '集章', value: '/packageA/pages/badge/badge' }
    ]
  },
  mutations: {
    set_config: (state, config) => {
      if (state.config != config) {
        state.config = {}
        setTimeout(() => {
          state.config = config
        }, 50)
      }
    },
    set_goods: (state, goods) => {
      if (state.goods_info != goods) {
        state.goods_info = {}
        setTimeout(() => {
          state.goods_info = goods
        }, 50)
      }
    },
    set_orderlist_date: (state, orderlist_date) => {
      state.actionRecord.orderlist_date = orderlist_date
    }
  }
}

export default page
